export const walton = function (walton: number, property: string = 'backgroundColor') {
	let color: string = `var(--walton-level-${Math.min(5, walton + 1)})`

	let result = {}
	result[property] = color
	return result
}
